import React from 'react';

import PanelWrapper from '@/components/PanelWrapper/PanelWrapper';

const NotFound404: React.FC = () => {
  return <PanelWrapper>404 Not Found</PanelWrapper>;
};

export default NotFound404;
